import { createReducer, on } from '@ngrx/store';
import * as NotesActions from './note.actions';
import { Note } from '../../notes/note';
import { DateRange } from '@angular/material/datepicker';

export interface NoteTableFilter {
  query: string;
  dateRange?: DateRange<Date>;
}

export interface NoteState {
  error: boolean;
  result: Partial<Note>;
  notes: Note[];
  tableFilter: NoteTableFilter;
}


const initialState: NoteState = {
  error: false,
  notes: [],
  result: {},
  tableFilter: {query: null}
};

export const NoteReducer = createReducer(
  initialState,
  // get notes
  on(NotesActions.fetchNotes, (state) => ({
    ...state,
    error: false,
  })),
  on(NotesActions.getNotesSuccess, (state, {notes} ) => {
    return ({
    ...state,
    notes,
  }); }),
  on(NotesActions.getNotesError, (state, action) => ({
    ...state,
    error: true,
  })),

  // load note
  on(NotesActions.fetchNotesDetail, (state) => ({
    ...state,
    noteDetailLoading: true,
  })),
  on(NotesActions.notesDetailLoaded, (state, action) => ({
    ...state,
    result: action.note,
    noteDetailLoading: false,
  })),
  on(NotesActions.notesDetailLoadError, (state, action) => ({
    ...state,
    noteDetailLoading: action.error,
  })),

  // add note
  on(NotesActions.noteSubmitted, (state, { note }) => ({
    ...state,
    result: note,
    error: false,
  })),
  on(NotesActions.noteSubmitOk, (state, { data }) => ({
    ...state,
    error: true,
    result: data,
  })),
  on(NotesActions.noteSubmitError, (state) => ({
    ...state,
    error: false,
  })),

  // edit note
  on(NotesActions.editNote, (state, { note }) => ({
    ...state,
    result: note,
    error: false,
  })),
  on(NotesActions.editNoteOk, (state, { data }) => ({
    ...state,
    error: true,
    result: data,
  })),
  on(NotesActions.editNoteError, (state) => ({
    ...state,
    error: false,
  })),

  // delete note
  on(NotesActions.deleteNoteRequest, (state, { id }) => ({
    ...state,
    result: undefined,
    error: false,
  })),
  on(NotesActions.deleteNoteSucess, (state, { result }) => ({
    ...state,
    result: undefined,
    error: true,
  })),
  on(NotesActions.deleteNoteError, (state) => ({
    ...state,
    error: false,
  })),
  on(NotesActions.updateTableFilter, (state, {tableFilter}) => ({
    ...state,
    tableFilter
  }))
);
